const ComponentType = {
    TABLE_FEE: 1,
}

export default ComponentType;
